import { __assign, __spreadArray } from "tslib";
import dayjs from "dayjs";
export var roundNumber = function (num, decimals) {
    return (Math.round(num * 100) / 100).toFixed(decimals);
};
export var reduceToDay = function (newArray, item) {
    if (item.id === null)
        return;
    var newTimeStamp = dayjs(item.id.timestamp)
        .set("hour", 0)
        .set("minute", 0)
        .set("second", 0)
        .set("ms", 0);
    var timeStampExists = newArray.find(function (arrayItem) {
        return newTimeStamp.isSame(arrayItem.id.timestamp);
    });
    if (!timeStampExists) {
        return __spreadArray(__spreadArray([], newArray, true), [item], false);
    }
    var updatedItem = __assign(__assign({}, newArray[newArray.length - 1]), { count: newArray[newArray.length - 1].count + item.count, impressions: newArray[newArray.length - 1].impressions + item.impressions, turnover: (newArray[newArray.length - 1].impressions + item.impressions) *
            0.0075 });
    return __spreadArray(__spreadArray([], newArray.slice(0, newArray.length - 1), true), [updatedItem], false);
};
export var reduceTo4H = function (newArray, item, index, oldArray) {
    if (index === void 0) { index = 0; }
    if (oldArray === void 0) { oldArray = []; }
    if (item.id === null)
        return;
    var newTimeStamp = dayjs(item.id.timestamp)
        .set("minute", 0)
        .set("second", 0)
        .set("ms", 0);
    var timeStampExists = newArray.find(function (arrayItem) {
        return newTimeStamp.isSame(arrayItem.id.timestamp);
    }) || newTimeStamp.get("h") % 4 !== 0;
    if (!timeStampExists) {
        return __spreadArray(__spreadArray([], newArray, true), [item], false);
    }
    var updatedItem = __assign(__assign({}, newArray[newArray.length - 1]), { count: newArray[newArray.length - 1].count + item.count, impressions: newArray[newArray.length - 1].impressions + item.impressions, turnover: (newArray[newArray.length - 1].impressions + item.impressions) *
            0.0075 });
    return __spreadArray(__spreadArray([], newArray.slice(0, newArray.length - 1), true), [updatedItem], false);
};
